import { JobStatusContent } from "./JobStatusContent";

export default JobStatusContent;
